import { List } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { CsatRating } from 'api/tasks';
import { ResponseListItem } from './item';

const ListItem = styled(List.Item)`
  padding: var(--spacing-03) 0;
`;

interface ResponsesProps {
  data: CsatRating[];
}

export const Responses: FC<ResponsesProps> = ({ data }) => (
  <List
    size="small"
    bordered={false}
    split={false}
    dataSource={data}
    renderItem={(item: CsatRating) => (
      <ListItem>
        <ResponseListItem
          user={item.ratedBy}
          rating={item.rating}
          comment={item.comment}
        />
      </ListItem>
    )}
  />
);
